module.exports = __webpack_public_path__ + "static/img/GNSS02.778e5388.png";